.menu {
  box-shadow: 0 0 7px 0 var(--shadow);
  width: 250px;
  border: 1px solid var(--menu-border);
  background-color: var(--main-background);
  position: absolute;
  z-index: 150;
}

.separator {
  margin: 2px 0;
  color: var(--dialog-border);
  border-width: 0;
  border-top: 1px solid var(--dialog-border);
}

.options {
  max-height: 350px;
  overflow: auto;
}

.option {
  padding: 6px 8px;
  display: flex;
  align-items: center;
}

.option svg {
  width: 0.8rem;
  margin-right: 10px;
}

.option-enabled {
  cursor: pointer;
}

.option-enabled:hover {
  background-color: var(--hover-light);
}

.option-disabled {
  color: var(--main-text-disabled);
}

.close-button {
  text-align: right;
  padding: 8px 10px;
}

.wrap {
  white-space: normal;
}
